import PropTypes from "prop-types";
import { Row, Select, Spin } from "antd";
import React, { useCallback, useEffect, useState } from "react";
import API from "../services/api-request";

const mergeUniqueById = (prevData, newData) => {
  const existingIds = new Set(prevData.map((item) => item.id));
  return [
    ...prevData,
    ...newData.filter((item) => !existingIds.has(item.id)),
  ];
};

const SelectRFID = ({ isAvailable = true, value, onChange }) => {
  const [listData, setListData] = useState([]);
  const [loading, setLoading] = useState(false);

  const getRFID = useCallback(async () => {
    setLoading(true);
    try {
      const res = await API.Get(isAvailable ? `rfid?isAvailable=${isAvailable}` : "rfid");
      const newData = res?.data || [];
      setListData((prevData) => mergeUniqueById(prevData, newData));
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }, [isAvailable]);

  useEffect(() => {
    getRFID();
  }, [getRFID]);

  return (
    <Select
      style={{ width: "100%" }}
      allowClear
      showSearch
      value={value || null}
      optionFilterProp="label"
      placeholder="Select RFID"
      onChange={onChange}
      notFoundContent={
        loading ? (
          <Row justify={"center"}>
            <Spin size="small" className="center" />
          </Row>
        ) : (
          "No Data"
        )
      }
      options={listData?.map((e) => ({
        label: e.number,
        value: e.id,
      }))}
    />
  );
};


SelectRFID.propTypes = {
  isAvailable: PropTypes.bool,
  value: PropTypes.any,
  onChange: PropTypes.func,
};

export default SelectRFID;
